module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_flower-fa31693085da674d30602a89afdc3d9e.png";